export default "__VITE_ASSET__CrOLbHMu__"